// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__36xkz","productName":"Table_productName__2cl43"};